<template>
  <Layout>
    <app-cobranza-tabla />
  </Layout>
</template>

<script>
import CobranzaTabla from "../components/CobranzaTabla/CobranzaTabla.vue";

export default {
  components: {
    "app-cobranza-tabla": CobranzaTabla
  }
};
</script>
